import { useMemo } from 'react'
import { useCyberStore } from '@entities/tsp'

interface useActiveCountryArgs {
  isSteam: boolean
  showVouchersForm: boolean
}

export const useActiveCountry = ({ isSteam, showVouchersForm }: useActiveCountryArgs) => {
  const { activeCountry, activeCountrySteam } = useCyberStore()

  const activeCountryItem = useMemo(() => {
    if (isSteam && !showVouchersForm) {
      return activeCountrySteam
    }

    return activeCountry
  }, [activeCountry, activeCountrySteam, isSteam, showVouchersForm])

  return { activeCountryItem }
}
